import { graphql } from '../graphql';

export const createReferralMutation = graphql(`
  mutation CreateReferral($email: String!, $message: String) {
    createReferral(email: $email, message: $message) {
      id
      referredEmail
      token
      accountCreatedAt
      organizationCreatedAt
      subscriptionStartedAt
      expiresAt
      createdAt
    }
  }
`);

export const deleteReferralMutation = graphql(`
  mutation DeleteReferral($id: ID!) {
    deleteReferral(id: $id)
  }
`);
